module.exports = __webpack_public_path__ + "img/intsummary.9de8371a.svg";